import { type IReferral } from '../../referral/referral';
import { type ITemplateContext } from '../templating';
import { type IBaseTemplateContext } from './base-context';
import { type IPatientScopeData } from './patient-context';
import { type WithRef } from '@principle-theorem/shared';

export interface IReferralScopeData extends IPatientScopeData {
  referral: WithRef<IReferral>;
  referrerAddress: string;
  recipientAddress: string;
}

export interface IReferralTemplateContext
  extends ITemplateContext,
    IBaseTemplateContext {
  referralReferrerFullName: string;
  referralReferrerFirstName: string;
  referralReferrerAddress: string;
  referralRecipientFullName: string;
  referralRecipientFirstName: string;
  referralRecipientAddress: string;
  referralUrgency: string;
  referralType: string;
  referralStatus: string;
}
